import update from "immutability-helper";

import {
  QUESTIONS_LOADING_START,
  QUESTIONS_LOADING_SUCCESS,
  QUESTIONS_LOADING_FAILED,
  SWITCH_QUESTIONS_FILTER,
  //Восстановление вопроса
  QUESTION_RESTORE_START,
  QUESTION_RESTORED_SUCCESSFULLY,
  //Перетаскивание вопроса
  QUESTIONS_SORTING_START,
  QUESTIONS_SORTED_SUCCESSFULLY,
  QUESTIONS_SORTING_FAILED,
  //Пагинация
  CHANGE_QUESTIONS_PAGE,
  CHANGE_QUESTIONS_LIMIT,
} from '../actions/questionsList';

import { SIGN_OUT } from '../actions/auth'; 

const INITIAL_STATE = { 
  ready: false,
  loading: false,
  questions: [],
  total: 0,
  limit: 10,
  activePage: 1,
  filters: {
    activeTab: 0,
    role: 'client',
    filter: 'visible'
  },
  updated: false,
};

export default function (state = INITIAL_STATE, action) { 
  switch (action.type) {
    case QUESTIONS_LOADING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        questions: [],
        total: 0,
        //updated: false,
      };
    case QUESTIONS_LOADING_SUCCESS:
      return {
        ...state,
        ready: true,
        loading: false,
        questions: action.payload.questions.menu,
        total: parseInt(action.payload.questions.count, 10),
      };
    case QUESTIONS_LOADING_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    //Фильтры
    case SWITCH_QUESTIONS_FILTER:
      return update(state, {
        filters: {
          activeTab: {$set: action.payload.tab.value},
          role: {$set: action.payload.tab.role},
          filter: {$set: action.payload.tab.filter},
        }
      });
    //Восстановление вопроса
    case QUESTION_RESTORE_START:
      return {
        ...state,
        updated: false,
      };
    case QUESTION_RESTORED_SUCCESSFULLY:
      return update(state, {
        updated: {$set: true},
        questions: {
          [action.payload.questionIndex]: {
            is_visible: {$set: action.payload.status},
          }
        },
      });
    //Перетаскивание вопроса
    case QUESTIONS_SORTING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        updated: false,
      };
    case QUESTIONS_SORTED_SUCCESSFULLY:
      return update(state, {
        updated: {$set: true},
        questions: {$set: []}
      });
    case QUESTIONS_SORTING_FAILED:
      return {
        ...state,
        ready: true,
        loading: false,
      };
    //Пагинация
    case CHANGE_QUESTIONS_PAGE:
      return {
        ...state,
        activePage: action.payload.activePage,
      };
    case CHANGE_QUESTIONS_LIMIT:
      return {
        ...state,
        limit: action.payload.activeLimit,
        activePage: INITIAL_STATE.activePage,
      };
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}